export const Roles = {
    USER : 'USER',
    ADMIN : 'ADMIN',
    NOMINAS : 'NOMINAS',
    WORKER : 'WORKER',
    FLUJO_DE_CAJA : 'FLUJO_DE_CAJA',
    USER_SMARTCFO : 'USER_SMARTCFO',
    COLABORADOR : 'COLABORADOR',
    FOUNDER: 'FOUNDER',
    SUPER_COLABORADOR: 'SUPER_COLABORADOR',
    USER_WITH_OUT_COBRANZA : 'USER_WITH_OUT_COBRANZA',
    USER_WITH_COBRANZA : 'USER_WITH_COBRANZA',
    OPERARIO : 'OPERARIO',
}